import { ApiStatus } from "~/api/fetchStudioApi";
import { Review, ReviewSubmitArgs } from "~/hooks/review/ReviewProvider";

import { fetchApi } from "./fetchStudioApi";

export const getProductReviews = async (productId: string): Promise<Review[]> => {
  const response = await fetchApi({
    path: "/getReviewsOfProduct?product_id=" + productId,
    method: "GET",
  });

  return response.reviews;
};

export const addProductReview = async ({
  productId,
  userId,
  reviewerName,
  reviewerProfileImageURL,
  reviewText,
  reviewScore,
  source,
}: ReviewSubmitArgs) => {
  const reviewObject = {
    productId: productId,
    userId: userId,
    reviewerName: reviewerName,
    reviewerProfileImageURL: reviewerProfileImageURL,
    reviewText: reviewText,
    reviewScore: reviewScore,
    source: source,
  };

  const response = await fetchApi({
    path: "/addReview",
    method: "POST",
    body: JSON.stringify({ review_object: reviewObject }),
    isJsonPayload: true,
    authRequired: true,
  });

  if (response.status === ApiStatus.SUCCESS) {
    return response;
  }
};
